import { trackMetaEvent } from './metaPixel';
import { trackGoogleEvent } from './googleAnalytics';

export type CertyEventName =
  | 'tool_start'
  | 'tool_complete'
  | 'tool_error'
  | 'tool_result_cta'
  | 'download_click'
  | 'pricing_view'
  | 'docs_click'
  | 'contact_submit'
  | 'subscription_confirmed';

export interface CertyEventParams {
  tool?: string;
  action?: string;
  source?: string;
  outcome?: string;
  plan?: string;
  currency?: string;
  value?: number;
  eventId?: string;
}

/**
 * Sends only a small, allow-listed set of product events after consent.
 * Callers must never pass certificate, document, identity or file data.
 */
export const trackEvent = (
  name: CertyEventName,
  params: CertyEventParams = {}
) => {
  if (typeof window === 'undefined') return false;
  const googleParams: Record<string, string | number> = {};
  for (const key of ['tool', 'action', 'source', 'outcome', 'plan', 'currency'] as const) {
    const value = params[key];
    if (typeof value === 'string' && /^[a-zA-Z0-9_/-]{1,100}$/.test(value)) googleParams[key] = value;
  }
  if (typeof params.value === 'number' && Number.isFinite(params.value) && params.value >= 0) googleParams.value = params.value;
  const googleSent = trackGoogleEvent(name, googleParams);
  if (name === 'download_click') return trackMetaEvent('DownloadClick');
  if (name === 'pricing_view') return trackMetaEvent('PricingClick');
  if (name === 'contact_submit') return trackMetaEvent('Lead');
  if (name === 'subscription_confirmed') {
    const { eventId, ...metaParams } = params;
    return trackMetaEvent('Subscribe', metaParams as Record<string, string | number>, eventId);
  }
  return googleSent;
};
